import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ThumbsDownSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M22 3h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V3zM2.17 10.12c-.11.25-.17.52-.17.8V12c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66a4.8 4.8 0 00.88 1.22L10 21l6.41-6.41c.38-.38.59-.89.59-1.42V5.33A2.34 2.34 0 0014.66 3H6.55c-.7 0-1.36.37-1.72.97l-2.66 6.15z", fill: "currentColor" })] })));
};

export { ThumbsDownSolidIcon };
//# sourceMappingURL=ThumbsDownSolidIcon.js.map
